import { DispatcherEvent } from '@carvana/merch-native';
import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import TradeContext from '~/context/common/TradeContext';
import sendMessageToNative from './sendMessageToNative';

export default function useTradeInAppliedDispatcher(): void {
  const { isTradeInApplied } = useContext(TradeContext);

  useSubsequentEffect(() => {
    sendMessageToNative(DispatcherEvent.ToggleTradeIn, { isTradeInApplied });
  }, [isTradeInApplied]);
}
